import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _uniqueId from "lodash/uniqueId";
import _without from "lodash/without";
import _reduce from "lodash/reduce";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { combineReducers } from 'redux';
import { ADD_ERROR_EXPLANATION_FEEDBACK, HIDE_COMPLETION_PANE, SET_HINT_SHOW, SET_RATING_STATUS, SHOW_SCT, TAKE_HINT, TAKE_SOLUTION } from './types';
const defaultLocalExercise = {
  completionPaneVisible: false,
  feedbackMessages: [],
  hintShown: false,
  lostXp: 0,
  solutionShown: 0,
  successMessage: ''
};
export const localExercisesReducer = function () {
  var _state$action$exercis;
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  const localExercise = (_state$action$exercis = state[action.exerciseId]) !== null && _state$action$exercis !== void 0 ? _state$action$exercis : _objectSpread({}, defaultLocalExercise);
  switch (action.type) {
    case HIDE_COMPLETION_PANE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, localExercise), {}, {
          completionPaneVisible: false
        })
      });
    case SHOW_SCT:
      {
        return _reduce(action.newOutputs, (acc, output) => {
          if (output.correct) {
            return _objectSpread(_objectSpread({}, state), {}, {
              [action.exerciseId]: _objectSpread(_objectSpread(_objectSpread({}, defaultLocalExercise), state[action.exerciseId]), {}, {
                completionPaneVisible: true,
                successMessage: output.message
              })
            });
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            [action.exerciseId]: _objectSpread(_objectSpread({}, localExercise), {}, {
              feedbackMessages: [...localExercise.feedbackMessages, output.messageId]
            })
          });
        }, state);
      }
    case SET_HINT_SHOW:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, localExercise), {}, {
          hintShown: action.hintShown
        })
      });
    case TAKE_HINT:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, localExercise), {}, {
          feedbackMessages: [...localExercise.feedbackMessages, action.messageId],
          hintShown: true,
          lostXp: localExercise.lostXp + action.xpCost
        })
      });
    case TAKE_SOLUTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, localExercise), {}, {
          feedbackMessages: action.message === undefined ? localExercise.feedbackMessages : _without(localExercise.feedbackMessages, action.messageId).concat(action.messageId),
          lostXp: localExercise.lostXp + action.xpCost,
          solutionShown: localExercise.solutionShown + 1
        })
      });
    case ADD_ERROR_EXPLANATION_FEEDBACK:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, localExercise), {}, {
          feedbackMessages: _without(localExercise.feedbackMessages, action.messageId).concat(action.messageId)
        })
      });
    default:
      return state;
  }
};
const AI_INCORRECT_SUBMISSIONS_ADDITION = '&nbsp;\n\n**Do you need additional hints?**\n\nIf you are stuck, you can ask our AI Assistant for exercise solution tips.';
export const getAiIncorrectSubmissionsBody = _ref => {
  let {
    body,
    isUserEnabledForAiIncorrectSubmissions
  } = _ref;
  if (!isUserEnabledForAiIncorrectSubmissions) {
    return body;
  }
  return "".concat(body, "\n\n").concat(AI_INCORRECT_SUBMISSIONS_ADDITION);
};
export const feedbackMessagesReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SHOW_SCT:
      {
        return _reduce(action.newOutputs, (acc, output) => {
          var _output$aiAssistant;
          if (output.correct) {
            return state;
          }
          const ratingData = action.isLoggedIn ? {
            isVisible: true,
            ratingStatus: 'NONE'
          } : {
            isVisible: false
          };
          return _objectSpread(_objectSpread({}, acc), {}, {
            [output.messageId]: {
              aiAssistantProps: output.aiAssistant,
              body: getAiIncorrectSubmissionsBody({
                body: output.message,
                isUserEnabledForAiIncorrectSubmissions: (_output$aiAssistant = output.aiAssistant) === null || _output$aiAssistant === void 0 ? void 0 : _output$aiAssistant.isUserEnabledForAiIncorrectSubmission
              }),
              key: _uniqueId(),
              messageType: 'INCORRECT',
              rating: ratingData,
              title: 'Incorrect'
            }
          });
        }, state);
      }
    case TAKE_HINT:
      {
        const ratingData = action.isLoggedIn ? {
          isVisible: true,
          ratingStatus: 'NONE'
        } : {
          isVisible: false
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.messageId]: {
            body: action.message,
            messageType: 'HINT',
            rating: ratingData,
            title: 'Hint'
          }
        });
      }
    case TAKE_SOLUTION:
      {
        if (action.message === undefined) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.messageId]: {
            body: action.message,
            markdown: action.solutionInstructions,
            messageType: 'SOLUTION',
            rating: {
              isVisible: false
            },
            title: 'Solution'
          }
        });
      }
    case SET_RATING_STATUS:
      {
        const rating = _get(state[action.messageId], 'rating');
        if (rating === undefined) {
          return state;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.messageId]: _objectSpread(_objectSpread({}, state[action.messageId]), {}, {
            rating: _objectSpread(_objectSpread({}, rating), {}, {
              ratingStatus: action.ratingStatus
            })
          })
        });
      }
    case ADD_ERROR_EXPLANATION_FEEDBACK:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.messageId]: {
            aiAssistantProps: action.aiAssistantProps,
            body: action.body,
            key: _uniqueId(),
            messageType: 'ASSISTANT',
            title: action.title
          }
        });
      }
    default:
      return state;
  }
};
export const rootReducer = combineReducers({
  feedbackMessages: feedbackMessagesReducer,
  localExercises: localExercisesReducer
});